export const enum ApiRetryMode {
	BaseGet = 'BaseGet'
}
